import { Component, OnInit, Input } from '@angular/core';
// Service
import { RulesChangeService } from '../../services/rules-change.service';
// Model
import { RulesEvents } from '../../models/inline-rules.event';

@Component({
	selector: 'cv-schema-render-add-comment',
	templateUrl: './add-comment.component.html'
})
export class AddCommentComponent implements OnInit {
	@Input() path;

	newComment;
	// processing = false;

	get processing(): boolean {
		return this.rulesChangeService.rulesWorkFlow.processing;
	}

	constructor(private rulesChangeService: RulesChangeService) {
		//
	}

	ngOnInit(): void {
		this.newComment = '';
	}

	/**
	 * Create a new Note/Comment on the Rule
	 */
	public async onCreateComment(): Promise<void> {
		this.rulesChangeService.rulesDataChanged.next({
			type: RulesEvents.NEW_COMMENT,
			newComment: this.newComment,
			path: this.path
		})
	}

}
